import React from 'react';
import { Paper, Typography, Stack, Divider, Box } from '@mui/material';
import ProfileSettings from './ProfileSettings';
import TaxCurrencySettings from './TaxCurrencySettings';
import UserManagement from './UserManagement';
import Notifications from './Notifications';
import BackupRestore from './BackupRestore';
import ReceiptSettings from './ReceiptSettings';
import BusinessInfo from './BusinessInfo';
import CashierDisplaySettings from './CashierDisplaySettings';

const Settings = ({ user, onUserUpdate }) => {
  return (
    <Paper sx={{ p: 4, mt: 4, maxWidth: 700, mx: 'auto' }}>
      <Typography variant="h5" fontWeight={700} mb={2}>Settings</Typography>
      <Divider sx={{ mb: 3 }} />
      <Stack spacing={4}>
        {/* Profile Settings */}
        <Box>
          <Typography variant="h6" fontWeight={600}>Profile</Typography>
          <Typography color="text.secondary" fontSize={15} mb={2}>Change your password and update your user info.</Typography>
          <ProfileSettings user={user} onUpdate={onUserUpdate} />
        </Box>
        <Divider />
        {/* Business Info */}
        <Box>
          <Typography variant="h6" fontWeight={600}>Business Info</Typography>
          <Typography color="text.secondary" fontSize={15} mb={2}>Store name, address, contact details, and legal information.</Typography>
          <BusinessInfo />
        </Box>
        <Divider />
        {/* Receipt/Invoice Settings */}
        <Box>
          <Typography variant="h6" fontWeight={600}>Receipt/Invoice Settings</Typography>
          <Typography color="text.secondary" fontSize={15} mb={2}>Customize receipt header/footer and invoice fields.</Typography>
          <ReceiptSettings />
        </Box>
        <Divider />
        {/* Tax & Currency */}
        <Box>
          <Typography variant="h6" fontWeight={600}>Tax & Currency</Typography>
          <Typography color="text.secondary" fontSize={15} mb={2}>Set default tax rate and currency symbol.</Typography>
          <TaxCurrencySettings />
        </Box>
        <Divider />
        {/* Cashier Display */}
        <Box>
          <Typography variant="h6" fontWeight={600}>Cashier Display</Typography>
          <Typography color="text.secondary" fontSize={15} mb={2}>Customize how cart items appear in the cashier screen.</Typography>
          <CashierDisplaySettings />
        </Box>
        <Divider />
        {/* User Management (admin only) */}
  {user?.user?.role === 'admin' && (
          <>
            <Box>
              <Typography variant="h6" fontWeight={600}>User Management</Typography>
              <Typography color="text.secondary" fontSize={15} mb={2}>Add/remove users, set roles and permissions.</Typography>
              <UserManagement />
            </Box>
            <Divider />
          </>
        )}
        {/* Backup & Restore */}
        <Box>
          <Typography variant="h6" fontWeight={600}>Backup & Restore</Typography>
          <Typography color="text.secondary" fontSize={15} mb={2}>Export/import data and download backups.</Typography>
          <BackupRestore />
        </Box>
        <Divider />
        {/* Notifications */}
        <Box>
          <Typography variant="h6" fontWeight={600}>Notifications</Typography>
          <Typography color="text.secondary" fontSize={15} mb={2}>Enable low stock alerts and sales summary emails.</Typography>
          <Notifications />
        </Box>
      </Stack>
    </Paper>
  );
};

export default Settings;
